import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m6 13 3 3 9-9a1.414 1.414 0 1 1 2 2l-9.586 9.586a2 2 0 0 1-2.828 0L4 15a1.414 1.414 0 1 1 2-2"
    }
  )
);
var SvgCheckOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CheckOutlined_default = SvgCheckOutlined;

export { CheckOutlined_default as default };
